<template>
<div>
  <div class="card" :class="showEditBorder" v-show="isEditing === false">
    <div class="card-title">
      <img :src="logo1x" :srcset="logo2x" alt="Site logo" v-show="site.logo" />
      <h3>{{ site.title }}</h3>
    </div>
    <div class="card-detail">
      <div class="card-detail-item">
        <img src="@/assets/icon_studio.svg" alt="Location icon">
        <p v-html="address"></p>
      </div>
      <div class="card-detail-item">
        <img src="@/assets/icon_call.svg" alt="Phone icon">
        <p>{{ phone }}</p>
      </div>
      <div class="card-detail-extras">
        <a :href="url" :class="isEmpty(this.site.url)" title="Visit website" target="_blank"><img src="@/assets/icon_website.svg" alt="Website URL icon"></a>
        <a :href="email" :class="isEmpty(this.site.email)" title="Send an email"><img src="@/assets/icon_email-thin.svg" alt="Email address icon"></a>
        <a :href="facebook" :class="isEmpty(this.site.facebook)" title="Visit on Facebook" target="_blank"><img src="@/assets/icon-fb-thin-sm.svg" alt="Facebook URL icon"></a>
        <a :href="insta" :class="isEmpty(this.site.insta)" title="Visit on Instagram" target="_blank"><img src="@/assets/icon_insta-thin.svg" alt="Instagram URL icon"></a>
      </div>
    </div>
    <div class="extra-content" v-show="$route.name==='editsites'">
      <button @click="showForm">Edit</button>
      <button @click="deleteSite(site)">Delete</button>
    </div>
  </div>

  <div class="site-card" v-show="isEditing === true">
    <label :for="'title-' + site._id">Site Title</label><br/>
    <input type="text" :id="'title-' + site._id" v-model="site.title" />
    <label :for="'logo-' + site._id">Logo URL</label><br />
    <input type="text" :id="'logo-' + site._id" v-model="site.logo" />
    <label :for="'address-' + site._id">Address</label><br />
    <input type="text" :id="'address-' + site._id" v-model="site.address" />
    <label :for="'phone-' + site._id">Phone</label><br />
    <input type="text" :id="'phone-' + site._id" v-model="site.phone" />
    <label :for="'url-' + site._id">URL</label><br />
    <input type="text" :id="'url-' + site._id" v-model="site.url" />
    <label :for="'email-' + site._id">Email</label><br />
    <input type="text" :id="'email-' + site._id" v-model="site.email" />
    <label :for="'insta-' + site._id">Instagram</label><br />
    <input type="text" :id="'insta-' + site._id" v-model="site.insta" />
    <label :for="'facebook-' + site._id">Facebook</label><br />
    <input type="text" :id="'facebook-' + site._id" v-model="site.facebook" />
    <p>Demo Center?<br/>
      <input type="radio" :id="'demo-' + site._id" v-model="site.demo" value="true" />
      <label :for="'demo-' + site._id">Yes</label>&nbsp;&nbsp;
      <input type="radio" :id="'demo-' + site._id" v-model="site.demo" value="false" />
      <label :for="'demo-' + site._id">No</label></p>
    <p>Training Center?<br/>
      <input type="radio" :id="'trainer-' + site._id" v-model="site.trainer" value="true" />
      <label :for="'trainer-' + site._id">Yes</label>&nbsp;&nbsp;
      <input type="radio" :id="'trainer-' + site._id" v-model="site.trainer" value="false" />
      <label :for="'trainer-' + site._id">No</label></p>
    <p>Publish?<br/>
      <input type="radio" :id="'published1-' + site._id" v-model="site.published" value="true" />
      <label :for="'published1-' + site._id">Yes</label>&nbsp;&nbsp;
      <input type="radio" :id="'published2-' + site._id" v-model="site.published" value="false" />
      <label :for="'published2-' + site._id">No</label></p>
    <div class="extra-content" v-show="$route.name==='editsites'">
      <button @click="updateSite(site)">Save</button>
      <button @click="hideForm">Cancel</button>
    </div>
  </div>
</div>
  
</template>

<script>
  export default {
    name: 'sitecard',

    props: {
      site: Object,
      isEditing: Boolean
    },

    computed: {
      logo1x() {
        const str = this.site.logo;
        const len = str.length;
        const name = str.slice( 0, len - 4 );
        const ext = str.slice( len - 4 );
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + name + "@1x" + ext;
      },

      logo2x() {
        const str = this.site.logo;
        const len = str.length;
        const name = str.slice( 0, len - 4 );
        const ext = str.slice( len - 4 );
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + name + "@2x" + ext + " 2x";
      },

      address() {
        let str = "";
        if (this.site.address) {
          str += this.site.address + "<br />";
        }
        if (this.site.city) {
          str += this.site.city;
        }
        if (this.site.city && (this.site.state || this.site.country)) {
          str += ", ";
        }
        if (this.site.state) {
          str += this.site.state + " ";
        }
        if (this.site.country) {
          str += this.site.country;
        }
        if (!this.site.address && !this.site.city && !this.site.state && !this.site.country) {
          return str = "None provided";
        }
        return str;
      },

      phone() {
        return this.site.phone === "" ? "None provided" : this.site.phone;
      },

      url() {
        return this.site.url === "none" ? "" : this.site.url;
      },

      email() {
        return this.site.email === "none" ? "" : "mailto:" + this.site.email;
      },

      insta() {
        return this.site.insta === "none" ? "" : "https://instagram.com/" + this.site.insta;
      },

      facebook() {
        return this.site.facebook === "none" ? "" : "https://facebook.com/" + this.site.facebook;
      },

      showEditBorder() {
        return this.site.published === false ? "red-border" : "test";
      }
    },

    methods: {
      showForm() {
        this.isEditing = true;
      },

      hideForm() {
        this.isEditing = false;
      },

      updateSite(site) {
        this.$emit('update-site', site);
      },

      deleteSite(site) {
        this.$emit('delete-site', site);
      },

      isEmpty(val) {
        return val === "none" ? "is-empty" : "";
      }
    }
  }
</script>

<style lang="scss" scoped>
.card, .site-card {
  background-color: var(--white);
  border-radius: 5px;
  border-bottom: 6px solid var(--black);
  box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.16);
  margin: 0 10px 20px;
  padding: 20px;
  width: 100%;
  max-width: 300px;
  height: 300px;
  position: relative;
}

.card-title {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  padding-bottom: 17px;
  border-bottom: 2px solid #dedede;
}

.card-title img {
  width: 115px;
  height: 70px;
  object-fit: contain;
  overflow: hidden;
}

.card-title h3 {
  font-family: var(--roboto);
  font-size: 1rem;
  line-height: 1.438;
  color: var(--black);
  margin: 0 0 0 15px;
  text-align: left;
}

.card-detail-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-bottom: 2px solid #dedede;
}

.card-detail-item img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.card-detail-item p {
  font-family: var(--roboto);
  font-size: 0.875rem;
  color: var(--black);
}

.card-detail-extras {
  display: flex;
  flex-flow: row nowrap;
}

.card-detail-extras img {
  width: 27px;
  height: 27px;
}

.card-detail-extras a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 44px;
  margin-top: 18px;
  border-right: 2px solid #dedede;
}

.card-detail-extras a:last-of-type {
  border-right: none;
}

.is-empty {
  pointer-events: none;
}

.is-empty img {
  filter: opacity(0.1);
}

.extra-content {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-46.5%);
  width: 100%;
}

.site-card {
  width: 300px;
  height: auto;
}

input {
  width: 100%;
  margin-bottom: 10px;
}

input[type=radio] {
 width: auto;
}

button {
  width: 40%;
  height: 30px;
  font-size: 1em;
  margin: auto;
  margin: 0 10px;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  transition: .2s;
  cursor: pointer;
}

button:hover {
  background-color: #808080;
}

.red-border {
  border: 2px solid red;
}
</style>
